<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex class="company-form-column company-identity-column" xs12 md4
						pl-4 pr-3 pt-4>
						<v-layout wrap>
							<v-flex xs12 class="company-form-section-title">
								<label>DATOS DE LA COMPAÑÍA</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Nombre"
									required
									v-model="$v.model.nombreComercial.$model"
									:error="$v.model.nombreComercial.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Razón Social"
									required
									v-model="$v.model.razonSocial.$model"
									:error="$v.model.razonSocial.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Código"
									required
									:disabled="codeCompanyDisabled"
									v-model="$v.model.codeCompany.$model"
									:error="$v.model.codeCompany.$error"
								>
								</v-text-field>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-text-field
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Ruc"
									required
									type="number"
									v-model="$v.model.ruc.$model"
									:error="$v.model.ruc.$error"
								>
								</v-text-field>
								<span class="form-group__message" v-if="!$v.model.ruc.required">
									Es necesario llenar este campo, es obligatorio.
								</span>
								<span class="form-group__message" v-if="!$v.model.ruc.minLength">
									Mínimo 13 caracteres numericos.
								</span>
							</v-flex>
							<template v-if="mode === 'create'">
								<v-flex xs12 class="company-form-section-title company-user-title">
									<label>USUARIO ADMINISTRADOR</label>
									<v-divider></v-divider>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										background-color="white"
										box
										class="body-1"
										hide-details
										label="Correo del administrador"
										type="email"
										v-model="$v.model.email.$model"
										:error="$v.model.email.$error"
									/>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										background-color="white"
										box
										class="body-1"
										hide-details
										label="Código de usuario"
										v-model="$v.model.codeUser.$model"
										:error="$v.model.codeUser.$error"
									/>
								</v-flex>
								<v-flex xs12>
									<v-text-field
										background-color="white"
										box
										class="body-1"
										hide-details
										label="Contraseña inicial"
										type="password"
										v-model="$v.model.password.$model"
										:error="$v.model.password.$error"
									/>
								</v-flex>
							</template>
						</v-layout>
					</v-flex>
					<v-flex class="company-form-column company-settings-column" xs12 md4 px-3 pt-4>
						<v-layout wrap>
							<v-flex xs12 class="company-form-section-title">
								<label>CONFIGURACIÓN GENERAL</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12 mb-1 v-if="flagCompanyParent">
								<v-select
									background-color="white"
									box
									hide-details
									item-text="nombreComercial"
									item-value="id"
									label="Compañía maestra"
									:items="masterCompanies"
									v-model="model.companyParentId"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-1>
								<v-select
								background-color="white"
								class="body-1 mt-2"
								box
								hide-details
								item-text="name"
								item-value="id"
								label="Template"
								:items="listTemplate"
								v-model="$v.model.idTemplate.$model"
								:error="$v.model.idTemplate.$error"
								@change="loadPlans"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3 v-if="plans">
								<v-select
									box
									background-color="white"
									class="body-1 mt-2"
									hide-details
									item-text="name"
									item-value="id"
									label="Planes"
									:items="plans"
									v-model="model.plans"
									return-object
									@change="onPlanChange"
								></v-select>
							</v-flex>
							<v-flex xs12 mb-3 v-if="mode === 'edit' && companyPlanSectionVisible">
								<section class="company-plan-limits" :class="{ active: companyPlanCustomized }">
									<div class="company-plan-renewal-header">
										<div class="company-plan-renewal-icon">
											<v-icon>tune</v-icon>
										</div>
										<div class="company-plan-renewal-copy">
											<strong>Plan de esta compañía</strong>
											<small>
												Ajusta los límites y funciones del plan solo para
												{{ model.nombreComercial || 'esta compañía' }}.
											</small>
										</div>
										<button
											v-if="companyPlanCustomized"
											type="button"
											class="company-plan-limits-reset"
											@click="resetCompanyPlan"
										>
											<v-icon small>restore</v-icon>
											Usar valores del plan
										</button>
									</div>
									<div class="company-plan-limits-grid" v-if="planHasSubsidiariesLimit">
										<label
											v-for="field in companyPlanFields"
											:key="field.key"
											class="company-plan-limits-field"
											:class="{ changed: isPlanFieldChanged(field.key) }"
										>
											<span>{{ field.label }}</span>
											<input
												type="number"
												min="0"
												:value="companyPlan[field.key]"
												@input="setPlanField(field.key, $event.target.value)"
											>
										</label>
									</div>
									<div class="company-plan-features" v-if="planHasAdditionalServices">
										<div class="company-plan-features-header">
											<span><v-icon>extension</v-icon></span>
											<div>
												<strong>Otras funciones del plan</strong>
												<small>
													Activa o desactiva lo que incluye el plan solo para esta compañía.
												</small>
											</div>
										</div>
										<div class="plan-services-grid">
											<button
												v-for="service in companyPlanServiceFields"
												:key="service.key"
												type="button"
												class="plan-service-card"
												:class="{
													'plan-service-card-active': companyPlanServices[service.key],
													'plan-service-card-changed': isPlanServiceChanged(service.key)
												}"
												:aria-pressed="Boolean(companyPlanServices[service.key])"
												@click="toggleCompanyPlanService(service.key)"
											>
												<span class="plan-service-icon">
													<v-icon>{{ service.icon }}</v-icon>
												</span>
												<span class="plan-service-copy">
													<strong>{{ service.label }}</strong>
													<small>{{ service.description }}</small>
												</span>
												<span class="plan-service-action">
													<v-icon>
														{{ companyPlanServices[service.key] ? 'check' : 'add' }}
													</v-icon>
												</span>
											</button>
										</div>
									</div>
								</section>
							</v-flex>
							<v-flex
								xs12
								mb-3
								v-if="mode === 'edit' && model.plans"
							>
								<section class="company-plan-renewal" :class="{ active: renewPlan }">
									<div class="company-plan-renewal-header">
										<div class="company-plan-renewal-icon">
											<v-icon>autorenew</v-icon>
										</div>
										<div class="company-plan-renewal-copy">
											<strong>Renovación del plan</strong>
											<small>Actívala y elige cuánto tiempo tendrá la nueva vigencia.</small>
										</div>
										<v-checkbox
											aria-label="Renovación del plan"
											class="company-plan-renewal-control"
											color="base"
											hide-details
											v-model="renewPlan"
										></v-checkbox>
									</div>
									<div class="company-plan-expiration" v-if="!renewPlan">
										<v-icon>event</v-icon>
										<div>
											<span>Fecha de caducidad actual</span>
											<strong>{{ currentPlanEndDate }}</strong>
										</div>
									</div>
									<div class="company-plan-renewal-period" v-if="renewPlan">
										<v-text-field
											background-color="white"
											box
											hide-details
											label="Cantidad"
											min="1"
											type="number"
											v-model.number="renewalAmount"
										></v-text-field>
										<v-select
											background-color="white"
											box
											hide-details
											label="Periodo"
											:items="renewalUnits"
											v-model="renewalUnit"
										></v-select>
									</div>
									<div class="company-plan-renewal-dates" v-if="renewPlan">
										<div>
											<span>Inicia</span>
											<strong>{{ renewalStartDate }}</strong>
										</div>
										<v-icon>arrow_forward</v-icon>
										<div>
											<span>Finaliza</span>
											<strong>{{ renewalEndDate }}</strong>
										</div>
									</div>
								</section>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
								background-color="white"
								box
								class="body-1"
								hide-details
								item-text="name"
								item-value="id"
								label="Distribuidores"
								:items="listDistributors"
								v-model="model.idDistributor"
								></v-select>
							</v-flex>
							<v-flex xs6 pr-2 mb-2>
								<v-select
								box
								background-color="white"
								class="body-1"
								hide-details
								label="País"
								item-text="name"
								item-value="id"
								:items="countries"
								v-model="$v.model.countryId.$model"
								:error="$v.model.countryId.$error"
								></v-select>
							</v-flex>
							<v-flex xs12 class="company-languages-section">
								<div class="company-languages-header">
									<div>
										<label>IDIOMAS</label>
										<small>Selecciona al menos un idioma para la compañía.</small>
									</div>
									<span>Obligatorio</span>
								</div>
								<v-layout v-if="hasLanguages" row wrap class="company-language-options">
									<v-flex xs6 class="company-language-option"
										v-for="(language, key) in languagesByProject"
										:key="key">
										<v-checkbox
											color="success"
											v-model="language.isSelected"
											hide-details
											:label="language.name || language.id || key"
											@change="selectLanguages(language, key)">
										</v-checkbox>
									</v-flex>
								</v-layout>
								<div v-else class="company-languages-empty">
									<v-icon>language</v-icon>
									<span>Este proyecto no tiene idiomas disponibles.</span>
								</div>
								<small v-if="languageSelectionInvalid && hasLanguages" class="company-languages-error">
									Debes seleccionar al menos un idioma.
								</small>
							</v-flex>
							<v-flex xs6>
								<v-checkbox
										color="success"
										label="Franquicia"
										v-model="flagFranchises"
									>
								</v-checkbox>
							</v-flex>
							<v-flex xs6>
								<v-checkbox
										color="success"
										label="Kardex"
										v-model="flagKardex"
									>
								</v-checkbox>
							</v-flex>
							<v-flex xs12>
								<v-checkbox
										color="success"
										label="Restringir accesos web services"
										v-model="model.flagAllowAccess"
									>
								</v-checkbox>
							</v-flex>
							<v-text-field
									 v-if="flagKardex === true"
									background-color="white"
									box
									class="body-1"
									hide-details
									label="Cantidad de Recalculos Kardex"
									required
									type="number"
									v-model="recalculateKardex"
								></v-text-field>
							<v-flex xs12>
								<label class="title-form pl-2">INTEGRAR APLICACIONES</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex mb-2 xs12 v-for="(item, index) in model.settings.serviceExternal" :key="index">
								<v-layout row align-center>
									<v-flex xs2>
										<v-switch
										class="mt-0"
										color="base"
										hide-details
										v-model="item.flagSelected"
										@change="changeState(index)"
										></v-switch>
									</v-flex>
									<v-flex xs10 class="title-validations">
										{{ item.title }}
									</v-flex>
								</v-layout>
								<v-layout column v-if="item.open">
									<v-flex xs12 mb-2>
										<label :ref="`json-${index}`" :for="`json-id-${index}`">
											<vue-six-four :id="`json-id-${index}`" hidden @vue-six-four="getFile($event, index)"/>
											<v-layout wrap>
												<v-flex xs10>
													<v-text-field
													box
													class="body-1 mb-3"
													label="Credencial"
													background-color="white"
													hide-details
													readonly
													v-model="item.credential">
													</v-text-field>
												</v-flex>
												<v-flex xs2 text-xs-left mt-3>
													<v-btn
													class="btn-action caption"
													color="base"
													@click="showDialog(`json-${index}`)"
													>Adjuntar Archivo</v-btn>
												</v-flex>
											</v-layout>
										</label>
									</v-flex>
									<v-flex xs12>
										<v-text-field
										box
										class="body-1 mb-3"
										label="URL"
										v-model="item.databaseURL"
										background-color="white"
										hide-details
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex class="company-form-column company-modules-column" xs12 md4 pr-4 pl-3 pt-4>
						<div v-if="mode === 'create' && model.idTemplate" class="template-modules-info">
							<v-icon>account_tree</v-icon>
							<div>
								<strong>Configuración administrada por el template</strong>
								<p>Las aplicaciones, módulos, roles y recursos se crearán usando el template seleccionado.</p>
							</div>
						</div>
						<template v-else>
						<v-layout wrap align-center>
							<v-flex xs12>
								<label class="title-form pl-2">LISTA DE MÓDULOS</label>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12 mb-3>
								<label class="title-form pl-2">Selecciona los módulos para tu compañía</label>
							</v-flex>
							<v-flex xs12 mb-3>
								<v-select
									background-color="white"
									box
									class="body-1"
									hide-details
									:items="apps"
									item-text="name"
									item-value="codeApp"
									label="Aplicaciones"
									v-model="codeApp"
									@input="loadModules"
								></v-select>
							</v-flex>
						</v-layout>
						<div class="company-modules-list">
						<section
							v-for="(module, moduleIndex) in modules"
							:key="module.id || module.codeModule || moduleIndex"
							class="module-config-item"
							:class="{ 'is-selected': module.isSelected }"
						>
							<header class="module-config-header">
							<div class="module-config-check">
								<v-checkbox
									class="mt-0"
									color="success"
									hide-details
									:disabled="expandDisabled"
									:label="module.name"
									v-model="module.isSelected"
									@change="removeModelModule(module, moduleIndex)" />
							</div>
							<button v-if="module.isSelected" type="button" title="Configurar módulo" @click="toggleModule(moduleIndex)">
								<span>Configurar</span><v-icon>chevron_right</v-icon>
							</button>
							</header>
						</section>
						</div>
						</template>
					</v-flex>
				</v-layout>
				<v-dialog v-model="moduleConfigDialog" max-width="610" content-class="module-config-dialog">
					<v-card v-if="selectedModuleConfig" class="module-config-card">
						<header class="module-config-dialog-header">
							<div>
								<small>CONFIGURACIÓN DEL MÓDULO</small>
								<h3>{{ selectedModuleConfig.name }}</h3>
								<p>Personaliza el nombre, la posición y el icono.</p>
							</div>
							<button type="button" title="Cerrar" @click="closeModuleConfig"><v-icon>close</v-icon></button>
						</header>
						<v-card-text class="module-config-content">
									<v-layout row wrap align-center
										v-for="(language, key) in selectedModuleConfig.languages"
										:key="key">
										<v-flex xs2 text-xs-right>
											<label>{{ language.id }}</label>
										</v-flex>
										<v-flex xs6>
											<v-text-field
												background-color="white"
												box
												class="body-1"
												hide-details
												label="Nombre"
												required
												v-model="language.name"
											>
											</v-text-field>
										</v-flex>
									</v-layout>
									<v-layout wrap align-center px-5>
										<v-flex xs12 sm4>
											<label>Posición</label>
										</v-flex>
										<v-flex xs12 sm5 pr-4>
											<v-text-field
												background-color="white"
												box
												class="body-1"
												hide-details
												type="number"
												min="1"
												label="Posición"
												v-model.number="selectedModuleConfig.position"
												@input="setPosition(selectedModuleConfig)"
											>
											</v-text-field>
										</v-flex>
										<v-flex xs12 sm4 pr-0>
											<upload-image
												:label-ref="`${selectedModuleConfig.id}-up`"
												:label-for="`${selectedModuleConfig.id}-image`"
												:input-id="`${selectedModuleConfig.id}-image`"
												:item-update="selectedModuleConfig"
												@send-image="sendImage"
											/>
										</v-flex>
										<v-flex xs12 sm8>
											<v-text-field
												solo
												class="body-1"
												hide-details
												readonly
												label="Icono"
											v-model="selectedModuleConfig.pathIcon"
											>
											</v-text-field>
										</v-flex>
									</v-layout>
						</v-card-text>
						<v-card-actions class="module-config-dialog-actions">
							<v-btn type="button" color="base" dark @click="closeModuleConfig">Listo <v-icon right>check</v-icon></v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						success-text="Grabar"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
	import VueSixFour from 'vue-six-four';
	import { required, requiredIf, minLength, email } from 'vuelidate/lib/validators';
	import uploadImage from '@/components/shared/upload-image';
	import {
		additionalServiceCodes,
		additionalServiceDefinition,
		parseAdditionalServices,
		toFeatureBoolean,
	} from '@/shared/plan-features';
	import { format, addDays, addMonths, addYears } from 'date-fns';

	// Límite del plan que se puede ajustar solo para una compañía.
	const PLAN_LIMIT_FIELDS = [
		{ key: 'subsidiaries_limit', label: 'Empresas / sucursales' },
	];

	function planLimitsFrom(plan) {
		const source = plan || {};
		return PLAN_LIMIT_FIELDS.reduce((acc, field) => ({
			...acc,
			[field.key]: Number(source[field.key]) || 0,
		}), {});
	}

	function planHandlesServices(plan) {
		return Object.keys(parseAdditionalServices(plan)).length > 0;
	}

	function planServicesFrom(plan) {
		const source = parseAdditionalServices(plan);
		return additionalServiceCodes(plan).reduce((acc, code) => ({
			...acc,
			[code]: toFeatureBoolean(source[code]),
		}), {});
	}

	const PAGE_COMPANY_LIST = 'page-company';

	async function getFile(fileInfo, index) {
		const newfile = {
			name: fileInfo.name.replace(/\s/g, '-'),
			base64data: fileInfo.sixFour,
		};
		const words = newfile.name.split('.');
		const lastItem = words.length;
		const extension = words[lastItem - 1];
		if (this.allowedFiles.indexOf(extension) > -1) {
			this.model.settings.serviceExternal[index].credential = newfile.base64data;
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	}

	function showDialog(prop) {
		this.$refs[prop][0].click();
	}

	function changeState(index) {
		this.model.settings.serviceExternal[index].open =
			!this.model.settings.serviceExternal[index].open;
	}

	async function created() {
		if (this.mode === 'edit') {
			const { data: record } = await this.$http.get(`company/${this.companyId}`);
			if (record.data) {
				const recordSettings = record.data.settings || {};
				const serviceExternal = Array.isArray(recordSettings.serviceExternal) ?
					recordSettings.serviceExternal : [];
				const selectedPlans = record.data.selectPlans;
				const selectedPlan = Array.isArray(selectedPlans) ? selectedPlans[0] : selectedPlans;
				this.model = {
					idTemplate: record.data.templateId,
					idDistributor: record.data.distributorId,
					nombreComercial: record.data.nombreComercial || '',
					razonSocial: record.data.razonSocial || '',
					codeCompany: record.data.codeCompany || '',
					ruc: record.data.ruc || '',
					languages: record.data.languages || {},
					modules: [],
					settings: { ...recordSettings, serviceExternal },
					countryId: record.data.country && record.data.country.data ?
						record.data.country.data.id : undefined,
					flagAllowAccess: record.data.flagAllowAccess === 1,
					plans: selectedPlan,
				};
				this.flagFranchises = Boolean(selectedPlan) &&
					toFeatureBoolean(selectedPlan.flag_franchises);
				this.flagKardex = Boolean(selectedPlan) &&
					(toFeatureBoolean(selectedPlan.flag_kardex) || toFeatureBoolean(selectedPlan.kardex));
				this.recalculateKardex = selectedPlan && selectedPlan.recalculate_kardex ?
					Number(selectedPlan.recalculate_kardex) : 0;
				this.companyPlan = planLimitsFrom(selectedPlan);
				this.companyPlanHasLimit = Boolean(selectedPlan) &&
					selectedPlan.subsidiaries_limit !== undefined && selectedPlan.subsidiaries_limit !== null;
				this.companyPlanServices = planServicesFrom(selectedPlan);
				this.companyPlanHasServices = planHandlesServices(selectedPlan);
				this.initialPlanSyncFingerprint = this.planSyncFingerprint();
				if (this.model.settings.serviceExternal.length === 0) {
					this.model.settings.serviceExternal = [...this.arrayDefault];
				} else {
					this.appMerge();
				}
				this.languagesByProject = record.data.languages || {};
			}
		} else {
			this.model.settings.serviceExternal = [...this.arrayDefault];
		}
		if (this.model.codeCompany && this.model.codeCompany.length) {
			this.codeCompanyDisabled = true;
		}
		const initialRequests = [
			this.loadTemplate(),
			this.loadDistributors(),
			this.loadCountries(),
			this.loadLanguages(),
		];
		await Promise.all(initialRequests);
		await this.loadApps();
		if (this.mode === 'create' && this.$route.query.templateId) {
			const templateId = Number(this.$route.query.templateId);
			this.model.idTemplate = Number.isNaN(templateId) ? this.$route.query.templateId : templateId;
			await this.loadPlans(this.model.idTemplate);
		}
	}

	async function loadPlans(event) {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		try {
			if (this.mode === 'create') this.model.plans = null;
			const { data: response } = await this.$http.get(`template/${event}`, { headers });
			if (!this.listTemplate.some(template => Number(template.id) === Number(response.data.id))) {
				this.listTemplate.push(response.data);
			}
			this.plans = typeof response.data.plans === 'string' ? [] : response.data.plans;
		} catch (error) {
			this.showError();
		}
	}

	async function loadCountries() {
		try {
			const response = await this.$http.get('countries');
			this.countries = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	async function loadMasterCompanies() {
		try {
			const { data: response } = await this.$http.get(`/projects/${this.codeProject}/company-parent`, {
				params: { page: 1 },
			});
			this.masterCompanies = response.data;
		} catch (error) {
			this.showError();
		}
	}

	function planForCommercial() {
		if (!this.model.plans || typeof this.model.plans !== 'object') {
			return null;
		}
		return {
			...this.model.plans,
			flag_franchises: Boolean(this.flagFranchises),
			flag_kardex: Boolean(this.flagKardex),
			recalculate_kardex: Number(this.recalculateKardex || 0),
			// Límite propio de esta compañía, solo si el plan lo maneja.
			...(this.planHasSubsidiariesLimit ? this.companyPlanValues() : {}),
			...(this.planHasAdditionalServices ?
				{ additional_services: this.companyPlanServicesValues() } : {}),
		};
	}

	function planSyncFingerprint() {
		const plan = this.planForCommercial();
		if (!plan) return null;
		const comparablePlan = { ...plan };
		delete comparablePlan.created_at;
		delete comparablePlan.start_date;
		delete comparablePlan.end_date;
		delete comparablePlan.updated_at;
		return JSON.stringify(comparablePlan);
	}

	function hasPlanSyncChanges() {
		return this.planSyncFingerprint() !== this.initialPlanSyncFingerprint;
	}

	function currentPlanEndDate() {
		const value = this.model.plans && this.model.plans.end_date;
		if (!value) return 'Sin fecha de caducidad';
		const normalizedValue = typeof value === 'string' ? value.replace(' ', 'T') : value;
		const endDate = new Date(normalizedValue);
		if (Number.isNaN(endDate.getTime())) return value;
		return endDate.toLocaleDateString('es-EC', {
			day: '2-digit',
			month: 'long',
			year: 'numeric',
		});
	}

	function renewalStartDate() {
		return format(new Date(), 'DD/MM/YYYY');
	}

	function renewalEndValue() {
		const amount = Number(this.renewalAmount);
		if (!Number.isInteger(amount) || amount < 1) return new Date();
		if (this.renewalUnit === 'days') return addDays(new Date(), amount);
		if (this.renewalUnit === 'months') return addMonths(new Date(), amount);
		return addYears(new Date(), amount);
	}

	function renewalEndDate() {
		return format(this.renewalEndValue, 'DD/MM/YYYY');
	}

	function renewalDurationInvalid() {
		const amount = Number(this.renewalAmount);
		return this.renewPlan && (!Number.isInteger(amount) || amount < 1 ||
			!['days', 'months', 'years'].includes(this.renewalUnit));
	}

	function onPlanChange(plan) {
		this.companyPlan = planLimitsFrom(plan);
		this.companyPlanServices = planServicesFrom(plan);
		this.companyPlanHasServices = planHandlesServices(plan);
	}

	// Plan global seleccionado (sin los cambios de esta compañía).
	function basePlan() {
		const id = this.model.plans && this.model.plans.id;
		return (this.plans || []).find(plan => Number(plan.id) === Number(id)) || this.model.plans || {};
	}

	function resetCompanyPlan() {
		this.companyPlanTouched = true;
		this.companyPlanServicesTouched = true;
		this.companyPlan = planLimitsFrom(this.basePlan());
		this.companyPlanServices = planServicesFrom(this.basePlan());
	}

	function toggleCompanyPlanService(key) {
		this.companyPlanServicesTouched = true;
		this.$set(this.companyPlanServices, key, !this.companyPlanServices[key]);
	}

	function isPlanServiceChanged(key) {
		return Boolean(this.companyPlanServices[key]) !==
			toFeatureBoolean(parseAdditionalServices(this.basePlan())[key]);
	}

	function setPlanField(key, value) {
		this.companyPlanTouched = true;
		this.$set(this.companyPlan, key, Math.max(0, Number(value) || 0));
	}

	function isPlanFieldChanged(key) {
		return Number(this.companyPlan[key] || 0) !== Number(this.basePlan()[key] || 0);
	}

	// El apartado solo se muestra si el plan trae subsidiaries_limit.
	function planHasSubsidiariesLimit() {
		const hasLimit = plan => Boolean(plan) && typeof plan === 'object' &&
			plan.subsidiaries_limit !== undefined && plan.subsidiaries_limit !== null;
		return hasLimit(this.model.plans) || hasLimit(this.basePlan());
	}

	function planHasAdditionalServices() {
		return this.companyPlanServiceFields.length > 0;
	}

	function companyPlanSectionVisible() {
		return this.planHasSubsidiariesLimit || this.planHasAdditionalServices;
	}

	function companyPlanCustomized() {
		const limitChanged = this.planHasSubsidiariesLimit &&
			this.companyPlanFields.some(field => this.isPlanFieldChanged(field.key));
		const serviceChanged = this.planHasAdditionalServices &&
			this.companyPlanServiceFields.some(service => this.isPlanServiceChanged(service.key));
		return limitChanged || serviceChanged;
	}

	// Solo se sobrescribe el límite de empresas; el resto del plan queda igual.
	function companyPlanValues() {
		return PLAN_LIMIT_FIELDS.reduce((values, field) => ({
			...values,
			[field.key]: Math.max(0, Number(this.companyPlan[field.key]) || 0),
		}), {});
	}

	function companyPlanServicesValues() {
		const stored = {
			...parseAdditionalServices(this.basePlan()),
			...parseAdditionalServices(this.model.plans),
		};
		return this.companyPlanServiceFields.reduce((values, field) => ({
			...values,
			[field.key]: Boolean(this.companyPlanServices[field.key]),
		}), stored);
	}

	function companyPlanServiceFields() {
		const base = parseAdditionalServices(this.basePlan());
		const own = parseAdditionalServices(this.model.plans);
		const source = { ...base, ...own };
		return additionalServiceCodes({ additional_services: source })
			.filter(code => toFeatureBoolean(base[code]) || toFeatureBoolean(own[code]))
			.map(code => additionalServiceDefinition(code))
			.map(service => ({
				key: service.code,
				label: service.name,
				description: service.description,
				icon: service.icon,
			}));
	}

	async function companyExistsInCommercial() {
		try {
			const response = await this.$httpSales.get(
				`/companies/${this.model.codeCompany}/acl`,
			);
			return Boolean(response && response.data && response.data.id);
		} catch (error) {
			const response = error && error.response ? error.response : {};
			const message = response.data && response.data.message;
			if (response.status === 404 || message === 'COMPANY_NOT_FOUND') {
				return false;
			}
			throw error;
		}
	}

	async function updatePlanInCommercial() {
		const plan = this.planForCommercial();
		if (!plan) return false;
		if (!await this.companyExistsInCommercial()) return null;
		let synchronizedPlan = { ...plan };
		if (this.renewPlan) {
			const currentDate = new Date();
			synchronizedPlan = {
				...synchronizedPlan,
				start_date: format(currentDate, 'YYYY-MM-DD HH:mm:ss'),
				end_date: format(this.renewalEndValue, 'YYYY-MM-DD HH:mm:ss'),
				updated_at: format(currentDate, 'YYYY-MM-DD HH:mm:ss'),
			};
		}
		const body = {
			plans: synchronizedPlan,
		};
		await this.$httpSales.patch(`/companies/${this.model.codeCompany}/plans`, body);
		return true;
	}

	function appMerge() {
		const newApps = this.arrayDefault.reduce((acum, item) => {
			const modelIndex = this.model.settings.serviceExternal.findIndex(
				se => se.title === item.title);
			if (modelIndex < 0) {
				acum.push(item);
			}
			return acum;
		}, []);
		this.model.settings.serviceExternal = this.model.settings.serviceExternal.concat(newApps);
	}

	async function loadTemplate() {
		const params = {
			page: 1,
		};
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		try {
			const response = await this.$http.get(`project/${this.codeProject}/template`, { params, headers });
			this.listTemplate = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	async function loadDistributors() {
		try {
			const response = await this.$http.get('distributaries');
			this.listDistributors = response.data.data;
		} catch (error) {
			this.showError();
		}
	}

	function closeModal() {
		if (this.$route.query.returnTo === 'page-template') {
			this.goTo('page-template', { params: { codeProject: this.codeProject }, query: {} });
			return;
		}
		const codeProject = this.codeProject;
		this.goTo(PAGE_COMPANY_LIST, { params: { codeProject } });
	}

	function expandDisabled() {
		let disabled = true;
		const languagesKeys = Object.keys(this.languagesByProject);
		languagesKeys.forEach((key) => {
			if (this.languagesByProject[key].isSelected) {
				disabled = false;
			}
		});
		return disabled;
	}

	function hasLanguages() {
		return Object.keys(this.languagesByProject).length > 0;
	}

	function languageSelectionInvalid() {
		return this.expandDisabled;
	}

	async function loadApps() {
		try {
			const { data: apps } = await this.$http.get(`project/${this.codeProject}/apps`);
			this.apps = apps.data;
			if (!this.apps.length) return;
			const requestedCodeApp = this.$route.query.codeApp;
			const requestedApp = this.apps.find(app => app.codeApp === requestedCodeApp);
			let assignedApp = null;
			if (this.mode === 'edit' && this.model.codeCompany) {
				const assignedApps = await this.loadCompanyApps();
				assignedApp = this.apps.find(app => assignedApps.some(
					companyApp => companyApp.codeApp === app.codeApp,
				));
			}
			this.codeApp = (requestedApp || assignedApp || this.apps[0]).codeApp;
			await this.loadModules(this.codeApp);
		} catch (err) {
			this.showError();
		}
	}

	async function loadCompanyApps() {
		try {
			const headers = {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			};
			const { data: response } = await this.$http.get(
				`project/${this.codeProject}/company/${this.model.codeCompany}/apps`,
				{ headers },
			);
			return Array.isArray(response.data) ? response.data : [];
		} catch (error) {
			return [];
		}
	}

	async function loadLanguages() {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		try {
			const { data: project } = await this.$http.get(`projects/${this.codeProject}`, { headers });
			const projectLanguages = project && project.data && project.data.languages ?
				project.data.languages : {};
			const companyLanguages = this.model.languages &&
				typeof this.model.languages === 'object' && !Array.isArray(this.model.languages) ?
				this.model.languages : {};
			const lang = {};
			Object.keys(projectLanguages).forEach((pLangKey) => {
				if (projectLanguages[pLangKey].isSelected) {
					const savedLanguage = companyLanguages[pLangKey];
					lang[pLangKey] = {
						...projectLanguages[pLangKey],
						...(savedLanguage || {}),
						isSelected: this.mode === 'edit' ?
							Boolean(savedLanguage && savedLanguage.isSelected !== false) : false,
					};
				}
			});
			Object.keys(companyLanguages).forEach((companyLangKey) => {
				if (!lang[companyLangKey]) {
					const savedLanguage = companyLanguages[companyLangKey] || {};
					lang[companyLangKey] = {
						...savedLanguage,
						isSelected: savedLanguage.isSelected !== false,
					};
				}
			});
			this.languagesByProject = { ...lang };
			this.model.languages = { ...lang };
			this.flagCompanyParent = Boolean(project.data.flagCompanyParent);
			if (this.flagCompanyParent) this.loadMasterCompanies();
		} catch (err) {
			this.showError();
		}
	}

	async function loadModules(code) {
		const query = {
			params: {
				codeCompany: this.mode === 'edit' ? this.codeCompany : null,
				codeProject: this.mode === 'edit' ? this.codeProject : null,
			},
			headers: {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			},
		};
		try {
			const { data: modulesData } = await this.$http.get(`app/${code}/modules`, query);
			this.modules = modulesData.data.map((module) => {
				const newModule = { ...module };
				const index = this.model.modules.findIndex(modMod => modMod.id === module.id);
				newModule.languages = {};
				newModule.isSelected = false;
				if (this.companyId && module.configLanguages) {
					newModule.languages = { ...module.configLanguages.languages };
					newModule.isSelected = true;
					newModule.pathIcon = module.configLanguages.pathIcon;
					newModule.position = module.configLanguages.position;
					delete newModule.configLanguages;
					if (index < 0) {
						this.model.modules.push(newModule);
					}
				} else if (this.model.modules.length > 0) {
					if (index < 0) {
						this.model.modules.push(newModule);
					} else {
						newModule.isSelected = this.model.modules[index].isSelected;
						newModule.languages = this.model.modules[index].languages;
						newModule.pathIcon = this.model.modules[index].pathIcon;
						newModule.position = this.model.modules[index].position;
					}
				} else {
					this.model.modules.push(newModule);
				}
				return newModule;
			});
			let languagesEmpty = true;
			Object.keys(this.languagesByProject).forEach((key) => {
				if (this.languagesByProject[key]) {
					languagesEmpty = false;
				}
			});
			if (!this.companyId && languagesEmpty) {
				this.loadLanguages();
			} else {
				Object.keys(this.languagesByProject).forEach((key) => {
					if (this.languagesByProject[key].isSelected) {
						this.selectLanguages(this.languagesByProject[key], key);
					}
				});
			}
			this.panel = this.modules.map(mod => mod.isSelected);
			const firstSelectedModuleIndex = this.modules.findIndex(mod => mod.isSelected);
			this.activeModuleIndex = firstSelectedModuleIndex >= 0 ? firstSelectedModuleIndex : null;
		} catch (err) {
			this.showError();
		}
	}

	function mode() {
		return this.companyId ? 'edit' : 'create';
	}

	function modelModulesEmpty() {
		return this.model.modules.every(modMod => !modMod.isSelected);
	}

	function removeModelModule(mod, moduleIndex) {
		if (mod.isSelected) {
			this.activeModuleIndex = moduleIndex;
		} else if (this.activeModuleIndex === moduleIndex) {
			this.activeModuleIndex = null;
			this.moduleConfigDialog = false;
		}
		if (!mod.isSelected) {
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				if (modModule.id === mod.id) {
					newModModule.isSelected = false;
				}
				return newModModule;
			});
		} else {
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				if (modModule.id === mod.id) {
					newModModule.isSelected = true;
				}
				return newModModule;
			});
		}
	}

	function toggleModule(moduleIndex) {
		this.activeModuleIndex = moduleIndex;
		this.moduleConfigDialog = true;
	}

	function closeModuleConfig() {
		this.moduleConfigDialog = false;
	}

	function selectedModuleConfig() {
		if (this.activeModuleIndex === null) return null;
		return this.modules[this.activeModuleIndex] || null;
	}

	function selectLanguages({ id, isSelected }, key) {
		if (isSelected) {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				if (!module.configLanguages && !module.languages[key]) {
					const newLanguage = { id, name: '' };
					newModule.languages[key] = newLanguage;
				}
				return newModule;
			});
			this.model.modules = this.model.modules.map((modMod) => {
				const newModMod = { ...modMod };
				if (!modMod.configLanguages && !modMod.languages[key]) {
					const newModLanguage = { id, name: '' };
					newModMod.languages[key] = newModLanguage;
				}
				return newModMod;
			});
		} else if (this.expandDisabled) {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				newModule.isSelected = false;
				delete newModule.languages[key];
				return newModule;
			});
			this.model.modules = this.model.modules.map((mod) => {
				const newMod = { ...mod };
				newMod.isSelected = false;
				delete newMod.languages[key];
				return newMod;
			});
		} else {
			this.modules = this.modules.map((module) => {
				const newModule = { ...module };
				delete newModule.languages[key];
				return newModule;
			});
			this.model.modules = this.model.modules.map((modModule) => {
				const newModModule = { ...modModule };
				delete newModModule.languages[key];
				return newModModule;
			});
		}
	}

	function sendImage({ urlImage, item }) {
		this.modules = this.modules.map((mod) => {
			const newMod = { ...mod };
			if (item.id === mod.id) {
				newMod.pathIcon = urlImage;
			}
			return newMod;
		});
		this.model.modules = this.model.modules.map((modModule) => {
			const newModModule = { ...modModule };
			if (item.id === modModule.id) {
				newModModule.pathIcon = urlImage;
			}
			return newModModule;
		});
	}

	function setPosition(module) {
		const { position } = module;
		const indexMod = this.model.modules.findIndex(mod => mod.id === module.id);
		this.model.modules[indexMod].position = position;
	}

	async function submitForm() {
		this.$v.$touch();
		if (this.renewalDurationInvalid) {
			this.showError('Ingresa una duración de renovación válida, mayor a cero.');
			return;
		}
		if (this.$v.$invalid || this.languageSelectionInvalid) {
			if (this.languageSelectionInvalid) {
				this.showError('Debes seleccionar al menos un idioma para la compañía.');
			}
			return;
		}
		const currentSettings = this.model.settings || {};
		const currentServices = Array.isArray(currentSettings.serviceExternal) ?
			currentSettings.serviceExternal : [];
		const serviceExternal = currentServices
			.filter(service => service.flagSelected)
			.map(service => ({ ...service }));
		const payload = {
			...this.model,
			settings: {
				...currentSettings,
				serviceExternal,
			},
		};
		payload.languages = this.languagesByProject;
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		let method = this.mode === 'create' ? 'post' : 'put';
		let url = this.mode === 'create' ? `company/${this.codeProject}/project` : `company/${this.codeCompany}`;
		const planChanged = this.mode === 'edit' &&
			(this.hasPlanSyncChanges() || this.renewPlan);
		if (this.mode === 'edit') {
			payload.codeProject = this.codeProject;
			payload.flagAllowAccess = Number(this.model.flagAllowAccess);
			payload.renewPlan = this.renewPlan;
			payload.renewalAmount = Number(this.renewalAmount);
			payload.renewalUnit = this.renewalUnit;
			// Límite de empresas solo para esta compañía (se guarda en su copia del plan).
			// Solo se envía si la compañía ya tenía uno propio o si se cambió aquí.
			if (this.planHasSubsidiariesLimit &&
				(this.companyPlanTouched || this.companyPlanHasLimit)) {
				payload.subsidiariesLimit = Math.max(0, Number(this.companyPlan.subsidiaries_limit) || 0);
			}
			if (this.planHasAdditionalServices &&
				(this.companyPlanServicesTouched || this.companyPlanHasServices)) {
				payload.additionalServices = this.companyPlanServicesValues();
			}
		}
		this.loading = true;
		payload.plans = this.model.plans && typeof this.model.plans === 'object' ?
			this.model.plans.id : this.model.plans;
		if (this.mode === 'create' && this.model.idTemplate) {
			const selectedTemplate = this.listTemplate.find(
				template => Number(template.id) === Number(this.model.idTemplate));
			payload.codeProject = this.codeProject;
			payload.codeTemplate = selectedTemplate ?
				selectedTemplate.codeTemplate : this.$route.query.codeTemplate;
			payload.flagFranchises = Boolean(this.flagFranchises);
			payload.flagKardex = Number(this.flagKardex);
			payload.recalculateKardex = Number(this.recalculateKardex || 0);
			payload.flagAppCompany = true;
			payload.flagAllowAccess = Number(this.model.flagAllowAccess);
			url = 'company-template';
			method = 'post';
		}
		try {
			await this.$http[method](url, payload, { headers });
			let commercialSyncFailed = false;
			if (planChanged) {
				try {
					const planSynchronized = await this.updatePlanInCommercial();
					commercialSyncFailed = planSynchronized === false;
				} catch (error) {
					commercialSyncFailed = true;
				}
			}
			if (commercialSyncFailed) {
				this.showNotification(
					'La compañía se guardó en ACL, pero no se pudo sincronizar el plan con Comercial.',
					'warning',
				);
			} else if (this.renewPlan) {
				this.showNotification('La compañía y la vigencia del plan se actualizaron correctamente.');
			} else {
				this.showNotification('La información de la compañía se guardó correctamente.');
			}
			this.closeModal();
		} catch (err) {
			if (err.status === 405) {
				if (err.data.message === 'MODULE_HAS_ASSOCIATED_DATA') {
					this.showError('Los módulos con permisos asignados deben ser seleccionados para poder grabar la información.',
						'info');
				}
			} else {
				const errorData = err && err.data ? err.data : {};
				const message = errorData.message || errorData.email || errorData.codeUser ||
					errorData.codeCompany;
				this.showError(message || undefined);
			}
		} finally {
			this.loading = false;
		}
	}

	function validations() {
		const validation = {
			model: {
				nombreComercial: {
					required,
				},
				razonSocial: {
					required,
				},
				codeCompany: {
					required,
				},
				ruc: {
					required,
					minLength: minLength(13),
				},
				idTemplate: {
					required,
				},
				countryId: {
					required,
				},
				plans: { required: requiredIf(() => this.plans) },
				email: {
					required: requiredIf(function createCompany() { return this.mode === 'create'; }),
					email,
				},
				codeUser: {
					required: requiredIf(function createCompany() { return this.mode === 'create'; }),
				},
				password: {
					required: requiredIf(function createCompany() { return this.mode === 'create'; }),
				},
			},
		};
		return validation;
	}

	function data() {
		return {
			activeModuleIndex: null,
			moduleConfigDialog: false,
			open: false,
			listDistributors: [],
			allowedFiles: ['json'],
			apps: [],
			codeApp: '',
			countries: [],
			flagCompanyParent: false,
			languagesByProject: {},
			flagFranchises: false,
			flagKardex: false,
			recalculateKardex: 0,
			companyPlan: planLimitsFrom(null),
			companyPlanHasLimit: false,
			companyPlanTouched: false,
			companyPlanFields: PLAN_LIMIT_FIELDS,
			companyPlanServices: planServicesFrom(null),
			companyPlanHasServices: false,
			companyPlanServicesTouched: false,
			listTemplate: [],
			masterCompanies: [],
			loading: false,
			initialPlanSyncFingerprint: null,
			renewPlan: false,
			renewalAmount: 1,
			renewalUnit: 'years',
			renewalUnits: [
				{ text: 'Días', value: 'days' },
				{ text: 'Meses', value: 'months' },
				{ text: 'Años', value: 'years' },
			],
			arrayDefault: [
				{
					id: 1,
					title: 'FIREBASE',
					flagSelected: false,
					typeId: 1,
					databaseURL: null,
					credential: null,
					open: false,
				},
				{
					id: 2,
					title: 'NETLIFY',
					flagSelected: false,
					typeId: 2,
					databaseURL: null,
					credential: null,
					open: false,
				},
			],
			model: {
				nombreComercial: '',
				razonSocial: '',
				codeCompany: '',
				countryId: null,
				companyParentId: null,
				email: '',
				codeUser: '',
				password: '',
				flagAllowAccess: false,
				idTemplate: null,
				idDistributor: null,
				ruc: '',
				plans: '',
				languages: {},
				modules: [],
				settings: {
					serviceExternal: [
						{
							id: 1,
							title: 'FIREBASE',
							flagSelected: false,
							typeId: 1,
							databaseURL: null,
							credential: null,
							open: false,
						},
						{
							id: 2,
							title: 'NETLIFY',
							flagSelected: false,
							typeId: 2,
							databaseURL: null,
							credential: null,
							open: false,
						},
					],
				},
			},
			module: {},
			modules: [],
			panel: [],
			plans: [],
			codeCompanyDisabled: false,
		};
	}

	export default {
		name: 'company-form',
		components: {
			uploadImage,
			VueSixFour,
		},
		computed: {
			companyPlanCustomized,
			companyPlanSectionVisible,
			companyPlanServiceFields,
			planHasAdditionalServices,
			planHasSubsidiariesLimit,
			currentPlanEndDate,
			expandDisabled,
			hasLanguages,
			languageSelectionInvalid,
			mode,
			modelModulesEmpty,
			renewalDurationInvalid,
			renewalEndDate,
			renewalEndValue,
			renewalStartDate,
			selectedModuleConfig,
		},
		created,
		data,
		methods: {
			changeState,
			closeModal,
			closeModuleConfig,
			getFile,
			appMerge,
			loadApps,
			loadCompanyApps,
			loadCountries,
			loadDistributors,
			loadLanguages,
			loadMasterCompanies,
			loadModules,
			loadTemplate,
			removeModelModule,
			selectLanguages,
			setPosition,
			sendImage,
			showDialog,
			submitForm,
			toggleModule,
			loadPlans,
			hasPlanSyncChanges,
			companyExistsInCommercial,
			planForCommercial,
			planSyncFingerprint,
			updatePlanInCommercial,
			onPlanChange,
			basePlan,
			resetCompanyPlan,
			setPlanField,
			isPlanFieldChanged,
			isPlanServiceChanged,
			toggleCompanyPlanService,
			companyPlanValues,
			companyPlanServicesValues,
		},
		props: {
			codeProject: {
				type: String,
			},
			companyId: {
				type: [Number, String],
			},
			codeCompany: {
				type: String,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.expansion-panel-modules {
		box-shadow: none;
		padding-bottom: 60px;

		.v-expansion-panel__header {
			padding: 0px 24px;
		}

		.v-input {
			margin-top: 0px;
		}

		.v-label {
			height: 100%;
			width: 100%;
		}
	}

	.expansion-disabled-modules {
		opacity: .6;
		pointer-events: none;
	}

	.title-validations {
		color: map-get($colors, base);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
	}

	.company-modules-column {
		padding-top: 18px !important;
	}

	.company-form-column {
		border-right: 1px solid #e7edf2;
		min-width: 0;
	}

	.company-modules-column { border-right: 0; }

	.company-form-section-title {
		margin-bottom: 11px;

		label {
			color: #29475f;
			font-family: map-get($fonts, open-bold);
			font-size: 11px;
			letter-spacing: .06em;
		}

		.divider { margin-top: 7px; }
	}

	.company-plan-renewal {
		background: #f7faf9;
		border: 1px solid #d7e4df;
		border-radius: 10px;
		padding: 11px 12px;
		transition: background-color .2s ease, border-color .2s ease;

		&.active {
			background: #eef7f3;
			border-color: #8bb7a9;
		}
	}

	.company-plan-limits {
		background: #f7faf9;
		border: 1px solid #d7e4df;
		border-radius: 10px;
		padding: 11px 12px;
		transition: background-color .2s ease, border-color .2s ease;

		&.active {
			background: #fff8ec;
			border-color: #e8c78a;
		}
	}

	.company-plan-limits-reset {
		align-items: center;
		background: #fff;
		border: 1px solid #d7e4df;
		border-radius: 999px;
		color: #1A4338;
		display: inline-flex;
		flex: 0 0 auto;
		font-size: 11px;
		font-weight: 600;
		gap: 4px;
		padding: 4px 10px;

		.v-icon { color: #1A4338; font-size: 15px; }
		&:hover { border-color: #8bb7a9; }
	}

	.company-plan-limits-grid {
		display: grid;
		gap: 8px;
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		margin-top: 10px;
	}

	.company-plan-limits-field {
		background: #fff;
		border: 1px solid #dce7e3;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding: 6px 10px;
		transition: border-color .15s ease;

		span {
			color: #718681;
			font-size: 10px;
			line-height: 1.3;
		}

		input {
			background: transparent;
			border: 0;
			color: #1A4338;
			font-size: 15px;
			font-weight: 700;
			outline: 0;
			padding: 0;
			width: 100%;
		}

		&:focus-within { border-color: #8bb7a9; }

		&.changed {
			border-color: #e8c78a;
			span { color: #a06a00; }
		}
	}

	.company-plan-features {
		border-top: 1px solid #e5ede9;
		margin-top: 12px;
		padding-top: 11px;
	}

	.company-plan-features-header {
		align-items: center;
		display: flex;
		gap: 9px;
		margin-bottom: 10px;

		> span {
			align-items: center;
			background: #eaf3ef;
			border: 1px solid #d9e9e2;
			border-radius: 9px;
			display: flex;
			flex: 0 0 30px;
			height: 30px;
			justify-content: center;
			width: 30px;

			.v-icon { color: #1A4338; font-size: 17px; }
		}

		> div { display: flex; flex-direction: column; }
		strong { color: #29445a; font-size: 12px; }
		small { color: #82928e; font-size: 9px; }
	}

	.plan-services-grid {
		display: grid;
		gap: 8px;
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.plan-service-card {
		align-items: center;
		background: #f7f9f8;
		border: 1px solid #dfe7e3;
		border-radius: 10px;
		color: #375248;
		display: flex;
		gap: 9px;
		min-height: 64px;
		padding: 9px;
		text-align: left;
		transition: .18s ease;
		width: 100%;

		&:hover {
			background: #f0f7f4;
			border-color: #a9c4b9;
			transform: translateY(-1px);
		}
	}

	.plan-service-card-active {
		background: #eaf5f0;
		border-color: #72a792;
		box-shadow: inset 3px 0 #1A4338;
	}

	.plan-service-card-changed { border-color: #e8c78a; }

	.plan-service-icon {
		align-items: center;
		background: #e7efeb;
		border-radius: 9px;
		display: flex;
		flex: 0 0 34px;
		height: 34px;
		justify-content: center;
		width: 34px;

		.v-icon { color: #547267; font-size: 18px; }
	}

	.plan-service-card-active .plan-service-icon {
		background: #1A4338;

		.v-icon { color: #fff; }
	}

	.plan-service-copy {
		display: flex;
		flex: 1;
		flex-direction: column;
		min-width: 0;

		strong { color: #315145; font-size: 10px; }
		small { color: #82928c; font-size: 8px; line-height: 1.35; margin-top: 2px; }
	}

	.plan-service-action {
		align-items: center;
		background: #e6ece9;
		border-radius: 50%;
		display: flex;
		flex: 0 0 24px;
		height: 24px;
		justify-content: center;
		width: 24px;

		.v-icon { color: #70847c; font-size: 15px; }
	}

	.plan-service-card-active .plan-service-action {
		background: #1A4338;

		.v-icon { color: #fff; }
	}

	.company-plan-renewal-header {
		align-items: center;
		display: flex;
		gap: 9px;
	}

	.company-plan-renewal-icon {
		align-items: center;
		background: #e4f0ec;
		border-radius: 8px;
		display: flex;
		height: 34px;
		justify-content: center;
		width: 34px;

		.v-icon {
			color: #1A4338;
			font-size: 20px;
		}
	}

	.company-plan-renewal-copy {
		display: flex;
		flex: 1;
		flex-direction: column;
		min-width: 0;

		strong {
			color: #29475f;
			font-size: 12px;
		}

		small {
			color: #718681;
			font-size: 10px;
			line-height: 1.35;
			margin-top: 2px;
		}
	}

	.company-plan-renewal-control {
		flex: 0 0 auto;
		margin: 0;
		padding: 0;
	}

	.company-plan-expiration {
		align-items: center;
		background: #fff;
		border: 1px solid #dce7e3;
		border-radius: 8px;
		display: flex;
		gap: 8px;
		margin-top: 10px;
		padding: 8px 10px;

		.v-icon {
			color: #1A4338;
			font-size: 18px;
		}

		> div {
			display: flex;
			flex-direction: column;
		}

		span {
			color: #718681;
			font-size: 9px;
			text-transform: uppercase;
		}

		strong {
			color: #29475f;
			font-size: 12px;
			margin-top: 1px;
		}
	}

	.company-plan-renewal-period {
		display: grid;
		gap: 8px;
		grid-template-columns: minmax(82px, .8fr) minmax(110px, 1.2fr);
		margin-top: 10px;

		.v-input {
			margin: 0;
		}
	}

	.company-plan-renewal-dates {
		align-items: center;
		border-top: 1px solid #d7e4df;
		display: grid;
		gap: 7px;
		grid-template-columns: 1fr auto 1fr;
		margin-top: 10px;
		padding-top: 10px;

		> div {
			display: flex;
			flex-direction: column;
		}

		span {
			color: #718681;
			font-size: 9px;
			text-transform: uppercase;
		}

		strong {
			color: #1A4338;
			font-size: 11px;
		}

		.v-icon {
			color: #71958a;
			font-size: 16px;
		}
	}

	.company-language-option {
		align-items: center;
		display: flex;
		min-height: 42px;
	}

	.company-languages-section {
		background: #f7faf9;
		border: 1px solid #d9e6e1;
		border-radius: 10px;
		margin-bottom: 10px;
		padding: 11px 12px 9px;
	}

	.company-languages-header {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 4px;

		label {
			color: #29475f;
			display: block;
			font-family: map-get($fonts, open-bold);
			font-size: 11px;
			letter-spacing: .06em;
		}

		small {
			color: #7a8d88;
			display: block;
			font-size: 10px;
			margin-top: 2px;
		}

		> span {
			background: #e8f3ef;
			border-radius: 10px;
			color: #1A4338;
			font-size: 9px;
			font-weight: 700;
			padding: 3px 7px;
			text-transform: uppercase;
		}
	}

	.company-language-options { margin: 0 -4px; }

	.company-languages-empty {
		align-items: center;
		color: #7b8e88;
		display: flex;
		font-size: 11px;
		gap: 6px;
		padding: 9px 0 4px;

		.v-icon { color: #8da39c; font-size: 18px; }
	}

	.company-languages-error {
		color: #d44d61;
		display: block;
		font-size: 10px;
		margin-top: 2px;
	}

	.company-settings-column .v-input--selection-controls {
		margin-top: 2px;
	}

	.company-user-title { margin-top: 14px; }

	.template-modules-info {
		align-items: flex-start;
		background: #eef6f3;
		border: 1px solid #c8ddd6;
		border-radius: 10px;
		display: flex;
		gap: 12px;
		margin-top: 4px;
		padding: 18px;

		.v-icon { color: #1A4338; }
		strong { color: #1A4338; display: block; margin-bottom: 6px; }
		p { color: #637b73; line-height: 1.45; margin: 0; }
	}

	@media (max-width: 959px) {
		.company-form-column {
			border-bottom: 1px solid #e7edf2;
			border-right: 0;
			padding-left: 22px !important;
			padding-right: 22px !important;
		}
	}

	.company-modules-list {
		background: #f5f8fb;
		border: 1px solid #dce6ee;
		border-radius: 11px;
		display: flex;
		flex-direction: column;
		gap: 5px;
		max-height: calc(100vh - 310px);
		overflow-y: auto;
		padding: 7px;
		scrollbar-color: #aac0d2 transparent;
		scrollbar-width: thin;
	}

	.module-config-item {
		background: white;
		border: 1px solid #e1e8ee;
		border-radius: 9px;
		overflow: hidden;
		transition: border-color .16s ease, box-shadow .16s ease;

		&.is-selected { border-color: #b9ddca; }
		&.is-open { border-color: #7fc9a1; box-shadow: 0 5px 13px rgba(31, 101, 66, .09); }
	}

	.module-config-header {
		align-items: center;
		display: flex;
		justify-content: space-between;
		min-height: 42px;
		padding: 4px 7px 4px 10px;

		.module-config-check { flex: 1 1 auto; min-width: 0; }
		.v-input { flex: 1; }
		button {
			align-items: center; background: #edf6fd; border: 0; border-radius: 7px; color: #2677b9;
			cursor: pointer; display: flex; font-size: 9px; gap: 3px; height: 29px; padding: 0 7px;
			pointer-events: auto;
			position: relative;
			z-index: 4;
			.icon { color: #2677b9; font-size: 17px; }
		}
	}

	.module-config-content {
		background: #fbfcfd;
		border-top: 1px solid #e8eef3;
		display: block;
		height: auto;
		min-height: 150px;
		overflow: visible;
		padding: 10px 9px 7px;
		position: relative;
		visibility: visible;
	}

	.module-config-content-title {
		display: flex;
		flex-direction: column;
		gap: 2px;
		margin: 0 4px 9px;

		strong { color: #294a63; font-size: 12px; }
		small { color: #7b8fa0; font-size: 10px; }
	}

	@media (max-width: 700px) {
		.company-modules-list { max-height: 52vh; }
		.module-config-header button span { display: none; }
	}
</style>

<style lang="scss">
.company-modules-list {
	.module-config-item { display: block !important; min-height: 44px !important; }
	.module-config-header {
		align-items: center !important;
		display: flex !important;
		height: auto !important;
		justify-content: space-between !important;
		min-height: 42px !important;
		visibility: visible !important;
	}
	.module-config-check {
		flex: 1 1 auto !important;
		min-width: 0 !important;
	}
	.module-config-check > .v-input,
	.module-config-check > .input-group {
		display: flex !important;
		flex: 1 1 auto !important;
		height: 34px !important;
		margin: 0 !important;
		max-height: 34px !important;
		min-height: 34px !important;
		opacity: 1;
		padding: 0 !important;
		visibility: visible !important;
	}
	.module-config-header .v-input__control,
	.module-config-header .v-input__slot,
	.module-config-header .input-group__input {
		height: 34px !important;
		min-height: 34px !important;
	}
	.module-config-header label {
		color: #38536a !important;
		font-size: 12px !important;
		opacity: 1 !important;
		visibility: visible !important;
	}
	.module-config-header .v-input__slot,
	.module-config-header .input-group__input { max-width: 100%; }
	.module-config-header > button { flex: 0 0 auto; pointer-events: auto !important; position: relative; z-index: 5; }
	.module-config-item.is-open {
		height: auto !important;
		max-height: none !important;
	}
	.module-config-item.is-open > .module-config-content {
		display: block !important;
		height: auto !important;
		min-height: 150px !important;
		overflow: visible !important;
		opacity: 1 !important;
		visibility: visible !important;
	}
}

.module-config-dialog {
	border-radius: 14px !important;
	overflow: hidden !important;
}
.module-config-card { background: #fff !important; }
.module-config-dialog-header {
	align-items: flex-start;
	background: linear-gradient(135deg, #f7fbff 0%, #eef7fd 100%);
	border-bottom: 1px solid #dce8f1;
	display: flex;
	justify-content: space-between;
	padding: 18px 20px 15px;
}
.module-config-dialog-header small { color: #2580c6; font-size: 9px; font-weight: 700; letter-spacing: .1em; }
.module-config-dialog-header h3 { color: #29465e; font-size: 18px; margin: 3px 0; }
.module-config-dialog-header p { color: #71879a; font-size: 11px; margin: 0; }
.module-config-dialog-header button {
	align-items: center; background: #fff; border: 1px solid #d6e3ed; border-radius: 8px;
	display: flex; height: 32px; justify-content: center; width: 32px;
}
.module-config-dialog-header button .icon { color: #627b8f; font-size: 19px; }
.module-config-dialog .module-config-content {
	background: #fff !important;
	border: 0 !important;
	max-height: 58vh;
	min-height: 190px !important;
	overflow-y: auto !important;
	padding: 18px 22px !important;
}
.module-config-dialog-actions {
	background: #f8fafc;
	border-top: 1px solid #e1e9f0;
	justify-content: flex-end;
	padding: 10px 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/companies/company-form.vue